import { i18nTranslate } from 'src/utils'

export const headerListArray = [
  {
    label: i18nTranslate('loyalty.date', 'Date Of Action'),
  },
  {
    label: i18nTranslate('loyalty.type', 'Action Type'),
  },
  // {
  //   label: i18nTranslate('loyalty.expirydate', 'Date Of Expiry'),
  //   // hide: storeContainer.isCARegion(),
  // },
  {
    label: i18nTranslate('loyalty.order', 'Order #'),
  },
  {
    label: i18nTranslate('loyalty.points', 'Reward Points'),
  },
]

export const loyaltyRewardsFormData = {
  dataTestId: 'loyalty-rewards',
  offTitle: i18nTranslate(
    'account.loyaltyOffTitle',
    'Would you like to Opt In to Nu Skin Rewards program?'
  ),
  onTitle: i18nTranslate(
    'account.loyaltyOnTitle',
    'You have now Opted in to Nu Skin Rewards program!'
  ),
  optOutTxt: i18nTranslate(
    'account.loyaltyoptOutTxt',
    'You are opted out of the Nu Skin Rewards Program!'
  ),
  optInTxt: i18nTranslate('account.loyaltyoptOffTxt', 'Opted In'),
  brandAffiliateUserTxt: i18nTranslate(
    'account.loyaltybrandAffiliateUserTxt',
    'Nu Skin Rewards Program is exclusively for Retail Customers and Members!'
  ),
  buyerUserTxt: i18nTranslate(
    'account.loyaltybuyerUserTxtTxt',
    'You are still not opted in to the Nu Skin Rewards Program. You will automatically be opted in when your Primary User opts in.'
  ),
}
